export const SDK_VERSION = '8.38.0';
